export default __webpack_public_path__ + "static/media/image1.eeec4672.jpeg";